<div class="row d-flex flex-wrap align-items-center">
    <div class="col-md-6 col-sm-12">
        <form autocomplete="off" [formGroup]="form">
            <div class="textOnInput">
                <label class="form-label">Filtrar comentarios : </label>
                <select class="form-select form-input" formControlName="idtier1"
                    (change)="getAllComments4T($event.target)">
                    <option selected disabled value=null>Perspectiva ...</option>
                    <option *ngFor="let t1 of tier1" value="{{t1.id}}">
                        {{t1.shorttitle}} {{t1.numberMessage}}
                    </option>
                </select>
            </div>
        </form>
    </div>
    <div class="col-md-6 col-sm-12">
        <div class="textOnInput">
            <label class="form-label">Buscar por comentario o ficha: </label>
            <input type="text" class="form-control form-input" placeholder="Buscar..."
                (input)="filterComments($event.target.value)">
        </div>
    </div>
</div>

<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Perspectivas </th>
                    <th scope="col">Ficha comentada</th>
                    <th scope="col">Comentario</th>
                    <th scope="col">Nombre y apellido</th>
                    <th scope="col">Correo</th>
                    <th scope="col">Estado</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let comment of filteredComments; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{comment.tier1 }}</td>
                    <td><a [routerLink]="['/ficha', comment.code]" class="link-class" target="_blank">{{
                            comment.longtitle }}</a></td>
                    <td>{{comment.body }}</td>
                    <td>{{comment.name }}</td>
                    <td>{{comment.email1 }}</td>
                    <td>
                        <div class="text-warning text-center" *ngIf="comment.isActive==='0'">INACTIVO</div>
                        <div class="label-active text-center" *ngIf="comment.isActive==='1'">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="comment.isActive==='2'">RECHAZADO</div>
                    </td>
                    <td>
                        <a class="a-icon text-center" title="Activar comentario"
                            *ngIf="comment.isActive==='0'|| comment.isActive==='2'"
                            (click)="editStatusComment(comment.id, '1', comment.email1)"><i
                                class="fa fa-check-circle i-icon"></i></a>
                    </td>
                    <td>
                        <a class="a-icon text-center" title="Activar y responder comentario"
                            *ngIf="comment.isActive==='0'|| comment.isActive==='1'" (click)="openModalReply(comment)"><i
                                class="fa fa-reply-all i-icon"></i></a>
                    </td>
                    <td>
                        <a class="a-icon text-center" title="Desactivar comentario"
                            *ngIf="comment.isActive==='0'|| comment.isActive==='1'"
                            (click)="editStatusComment(comment.id, '0', comment.email1)"><i
                                class="fa fa-share i-icon"></i></a>
                    </td>
                    <td>
                        <a class="a-icon text-center" title="Rechazar comentario"
                            *ngIf="comment.isActive==='0' || comment.isActive==='1'"
                            (click)="editStatusComment(comment.id, '2', comment.email1)"><i
                                class="fa fa-trash i-icon"></i></a>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>
    <ng-container *ngIf="!status">
        <div class="alert alert-warning text-center" role="alert" style="width: 100%;">
            Esta sección no tiene comentarios para mostrar
        </div>
    </ng-container>
</div>

<!--Empieza modal responder -->

<div class="modal fade" id="replyModal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Responder comentario</h5>
                <a type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></a>
            </div>

            <div class="modal-body">

                <form [formGroup]="formdata" (ngSubmit)="save()" class="my-4">

                    <div class="row mt-2">
                        <div class="col-12">
                            <textarea class="form-control" formControlName="body" rows="10"
                                placeholder="Comentario"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-outline-success btn-sm">Guardar</button>
                        <button type="button" class="btn btn-outline-secondary btn-sm"
                            data-dismiss="modal">Cancelar</button>
                    </div>

                </form>

            </div>



        </div>
    </div>
</div>
<!--Termina modal responder -->